import { createSlice } from "@reduxjs/toolkit";
import { guestUserPhoneLoginAPI } from "../../../services/guestUsers/guestUserAllAPIService";
import { STATUS_CODE } from "../../../common";
import { setItem } from "../../../common/localStorage";
import { GUEST_TOKEN_KEY } from "../../../common/authSession";

const data = {
  isLoading: false,
  error: "",
  message: "",
  data: null,
};

const guestUserPhoneLoginSlice = createSlice({
  name: "guestUserPhoneLoginSlice",
  initialState: data,
  reducers: {
    guestUserPhoneLoginSliceInfo(state) {
      state.isLoading = true;
      state.message = "";
    },
    guestUserPhoneLoginSliceSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
      state.message = "";
    },
    guestUserPhoneLoginSliceFailure(state, action) {
      state.isLoading = false;
      state.message = action.payload;
      state.data = null;
    },
    guestUserPhoneLoginSliceReset(state) {
      state.isLoading = false;
      state.message = "";
      state.data = null;
      state.error = "";
    },
  },
});

export const guestUserPhoneLoginHandler = (payload) => async (dispatch) => {
  try {
    dispatch(guestUserPhoneLoginSliceAction.guestUserPhoneLoginSliceInfo());
    const response = await guestUserPhoneLoginAPI(payload);
    dispatch(guestUserPhoneLoginSliceAction.guestUserPhoneLoginSliceSuccess(response));

    if (response?.statusCode === STATUS_CODE.OK) {
      localStorage.setItem(GUEST_TOKEN_KEY, response?.data?.token);
      setItem("guestLoginResponse", response?.data);
    }
  } catch (e) {
    const message =
      typeof e === "string"
        ? e
        : e?.message || e?.response?.data?.message || "Something went wrong";
    dispatch(guestUserPhoneLoginSliceAction.guestUserPhoneLoginSliceFailure(message));
  }
};

export default guestUserPhoneLoginSlice.reducer;
export const guestUserPhoneLoginSliceAction = guestUserPhoneLoginSlice.actions;
